import React, { useState } from "react";
import { TreeSelect } from "antd";
import styled from "styled-components";

// Tree data for the TreeSelect component
const treeData = [
  {
    value: "2024",
    title: "2024",
    children: [
      {
        value: "tyota",
        title: "tyota",
        children: [
          {
            value: "leaf1",
            title: "my leaf",
          },
          {
            value: "leaf2",
            title: "your leaf",
          },
        ],
      },
      {
        value: "parent 1-1",
        title: "parent 1-1",
        children: [
          {
            value: "sss",
            title: (
              <b
                style={{
                  color: "#08c",
                }}
              >
                sss
              </b>
            ),
          },
        ],
      },
    ],
  },
  {
    value: "2023",
    title: "2023",
    children: [
      {
        value: "parent 1-0",
        title: "parent 1-0",
        children: [
          {
            value: "leaf1",
            title: "my leaf",
          },
          {
            value: "leaf2",
            title: "your leaf",
          },
        ],
      },
      {
        value: "parent 1-1",
        title: "parent 1-1",
        children: [
          {
            value: "sss",
            title: (
              <b
                style={{
                  color: "#08c",
                }}
              >
                sss
              </b>
            ),
          },
        ],
      },
    ],
  },
];

// Styled TreeSelect component
const StyledTreeSelect = styled(TreeSelect)`
  &.custom-selector {
    .ant-select-selector {
      background-color: #fbf7fb;
      color: white;
      height: 48px !important;
      border-radius: 5px !important;
      border-color: #eee !important;
    }

    .ant-select-arrow {
      color: white;
    }

    .ant-select-selection-item {
      color: white;
    }

    .ant-select-clear {
      color: white;
    }
  }

  .ant-select-dropdown {
    background-color: #36424e;
    color: white;

    .ant-select-tree {
      background-color: #36424e;
      color: white;

      .ant-select-tree-treenode {
        color: white;

        &:hover {
          background-color: #485666;
        }

        &.ant-select-tree-treenode-selected {
          background-color: #576b7d;
        }
      }
    }
  }
`;

const TreeSelector = () => {
  const [value, setValue] = useState();

  const onChange = (newValue) => {
    // console.log(newValue);
    setValue(newValue);
  };

  return (
    <StyledTreeSelect
      size="large"
      showSearch
      className="custom-selector"
      style={{
        width: "100%",
      }}
      value={value}
      dropdownStyle={{
        maxHeight: 400,
        overflow: "auto",
      }}
      placeholder="Make/Model/Version"
      allowClear
      multiple
      treeDefaultExpandAll
      onChange={onChange}
      treeData={treeData}
    />
  );
};

export default TreeSelector;
